module.exports = __webpack_public_path__ + "img/goalbook-1.5703cedd.jpg";